import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=0cdfffb3"
import script from "./AddProperty.vue?vue&type=script&lang=js"
export * from "./AddProperty.vue?vue&type=script&lang=js"
import style0 from "./AddProperty.vue?vue&type=style&index=0&id=0cdfffb3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports